export enum LoginFlowType {
  RX = "RX",
  UNKNOWN = "UNKNOWN"
}
